export default __webpack_public_path__ + "static/RobotoCondensed-Bold-89a396525c0de98da36505cb04eb9373.ttf";